import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardPage { 
  title = "Dashboard"
}